import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const WrapperExternalAuthOptions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${tokens.spacing.verticalXsmall} ${tokens.spacing.horizontalMedium};
  margin-bottom: ${tokens.spacing.verticalSmall};
`
